import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {}

  submit(event) {
    event.stopPropagation();

    var formURL = this.element.getAttribute("action");
    var formData = new FormData(this.element);
    $.ajax({
      url: formURL,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
      async: true,
      cache: false,
      enctype: "multipart/form-data",
      dataType: "json",
      success: function (data) {
        if (data.success) {
          alert(data.success);
        }

        if (data.error) {
          alert(data.error);
        }
      },
    });
  }
}
